export default "__VITE_ASSET__D83xzXuz__"